const findClassName = (tokens, pos) => {
  const closerTokenIndex = pos - 1;
  const targetTokenIndex = pos - 2;

  if (!tokens[closerTokenIndex] || !tokens[targetTokenIndex]) {
    return false;
  }

  if (tokens[closerTokenIndex].type !== 'paragraph_close' || tokens[targetTokenIndex].type !== 'inline' || !tokens[targetTokenIndex].content.startsWith('.')) {
    return false;
  }

  return targetTokenIndex;
};

module.exports = function blockClass(md) {
  md.core.ruler.push('block_class', function append(state) {
    for (let i = state.tokens.length - 1; i >= 0; i--) {
      const token = state.tokens[i];

      if (!['table_open', 'dl_open', 'bullet_list_open', 'ordered_list_open', 'section_open'].includes(token.type)) {
        continue;
      }

      const targetTokenIndex = findClassName(state.tokens, i);
      if (!targetTokenIndex) {
        continue;
      }

      const attrs = token.attrs || [];
      attrs.push([
        'class',
        state.tokens[targetTokenIndex].content.substr(1).split(/[ .]+/g).join(' '),
      ]);
      token.attrs = attrs;

      for (let j = i - 1; j >= 0; j--) {
        state.tokens[j].toBeRemoved = true;

        if (state.tokens[j].type === 'paragraph_open') {
          break;
        }
      }
    }

    state.tokens = state.tokens.filter((v) => !v.toBeRemoved);
  });
};
